<div #pageContainer class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">

        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-8 truncate">
            Work Planning Budget
        </div>

        <form [formGroup]="searchForm">
            <app-table-filter [searchForm]="searchForm" class="text-primary" (searchTriggered)="handleSearch($event)"></app-table-filter>

            <div class="grid grid-cols-1 sm:grid-cols-3">
                <div class="flex justify-start col-span-2">
                    <div class="w-19 ml-2">
                        <mat-form-field class="w-full no-bottom-gap mb-2">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                                <mat-option [value]="50"> 50 </mat-option>
                                <mat-option [value]="100"> 100 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                    (apply)="applySort($event)">
                    </app-sort-menu>

                    <button class="btn btn-outline btn-default dt-download"  matTooltip="Download Records" (click)="downloadWpb()">
                        <mat-icon class="text-primary hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                    </button>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-outline" (click)="createWPB()" matTooltip="Add Work Planning Budget">
                        <mat-icon class="text-primary hover:text-white" svgIcon="add"></mat-icon>
                    </button>
                    <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                        Search
                    </button>
                    <button class="btn btn-outline btn-default" (click)="reset()">
                        Reset
                    </button>
                    <button class="btn btn-outline btn-default mx-2 hover:text-white"  matTooltip="Refresh Table"
                        (click)="setPage({ offset: dt.page.offset })">
                        <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                    </button>
                </div>

                <div class="flex justify-start col-span-2">
                    <span class="self-center font-medium text-gray-400 italic text-md p-2">
                        Sorting by {{ sortInfo }}
                    </span>
                </div>
    
                <div class="flex justify-end">
                    <span class="self-center font-medium text-primary text-md p-2">
                        {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
                </div>
            </div>
        </form>

        <div class="grid overflow-x-auto">
            <!-- Header -->
            <div class="table-wpb-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                matSort matSortDisableClear>
                <div class="border py-8 text-center">
                    No
                </div>

                <div [mat-sort-header]="'fieldLongName'" class="flex justify-center border py-4 my-custom-sort-header">
                    Field
                </div>

                <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                    Platform
                </div>

                <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                    Well
                </div>

                <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                    Well String
                </div>

                <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                    String Indicator
                </div>

                <div [mat-sort-header]="'wpbStatus'" class="flex border justify-center py-4">
                    Status
                </div>

                <div [mat-sort-header]="'integrityIssue'" class="flex border justify-center py-4">
                    Integrity Issue
                </div>

                <div [mat-sort-header]="'submissionDate'" class="flex border justify-center py-4">
                    Submission Date
                </div>

                <div [mat-sort-header]="'submissionYear'" class="flex border justify-center py-4">
                    Submission Year
                </div>

                <div [mat-sort-header]="'submissionType'" class="flex border justify-center py-4">
                    Submission Type
                </div>

                <div [mat-sort-header]="'planExecutionDate'" class="flex border justify-center py-4">
                    Plan <br> Execution Date
                </div>

                <div [mat-sort-header]="'planCostRmMil'" class="flex border justify-center py-4">
                    Plan Cost <br> (RM/Mil)
                </div>

                <div [mat-sort-header]="'proposalDesc'" class="flex border justify-center py-4">
                    Proposal Description
                </div>

                <div [mat-sort-header]="'remark'" class="flex border justify-center py-4">
                    Remark
                </div>

                <div [mat-sort-header]="'updateDate'" class="flex border justify-center py-4">
                    Updated Date
                </div>

                <div [mat-sort-header]="'updateBy'" class="flex border justify-center py-4">
                    Updated By
                </div>

                <div class="block border text-center py-8">
                    Action
                </div>

            </div>
            <!-- Rows -->
            <ng-container *ngIf="dt.rows.length; else noRecords">
                <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                    <div class="table-wpb-record-grid grid items-center border-b"
                        [ngClass]="{'bg-primary-100': i % 2 }">

                        <!-- No -->
                        <div class="py-4 text-center">
                            {{startingIndex + i + 1}}.
                        </div>

                        <!-- Field Long Name -->
                        <div class="flex truncate justify-center">
                            {{ row.fieldLongName }}
                        </div>

                        <!-- Platform Long Name  -->
                        <div class="flex justify-center">
                            {{ row.platformLongName }}
                        </div>

                        <!-- Well Long Name  -->
                        <div class="flex justify-center">
                            {{ row.wellLongName }}
                        </div>

                        <!-- String Short Name  -->
                        <div class="text-center">
                            {{ row.stringShortName }}
                        </div>

                        <!-- String Indicator -->
                        <div class="block text-center">
                            {{ row.stringIndicatorShortName }}
                        </div>

                        <!-- Status -->
                        <div class="text-center mx-2">
                            <div [ngClass]="{ 'warningBadge' : row.wpbStatus === 'Open', 'successBadge' : row.wpbStatus === 'Closed' }">
                            {{ row.wpbStatus || '-' }}
                            </div>
                        </div>

                        <!-- Integrity Issue -->
                        <div class="block text-center py-2">
                            {{ row.integrityIssue || '-' }}
                        </div>

                        <!-- Submission Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.submissionDate, false) || '-' }}
                        </div>

                        <!-- Submission Year -->
                        <div class="block text-center">
                            {{ row.submissionYear || '-' }}
                        </div>

                        <!-- Submission type -->
                        <div class="block text-center">
                            {{ row.submissionType || '-' }}
                        </div>

                        <!-- Plan Execution Date -->
                        <div class="block text-center mx-2">
                            {{ handleFormatDate(row.planExecutionDate, false) || '-' }}
                        </div>

                        <!-- Plan Cost (RM/Mil) -->
                        <div class="block text-center">
                            {{ row.planCostRmMil || '-' }}
                        </div>

                        <!-- Propasal Desc -->
                        <div class="block text-center py-2">
                            {{ row.proposalDesc || '-' }}
                        </div>

                        <!-- Remark -->
                        <div class="block text-center">
                            {{ row.remark || '-' }}
                        </div>

                        <!-- Updated Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.updateDate, false) || '-' }}
                        </div>

                        <!-- Updated By -->
                        <div class="block text-center">
                            {{ row.updateBy || '-' }}
                        </div>

                        <!-- Action -->
                        <div class="block text-center">
                            <button class="btn btn-remove-bg" [disabled]="row['source'] == 'FN'"
                                (click)="editWPB(row.id)">
                                <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:pencil-square'" matTooltip="Edit"></mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noRecords>
                <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                    There are no records registered!
                </div>
            </ng-template>
        </div>

        <div
            class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
            <div class="content-center px-3">
                {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                    <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                        [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                        [hidePageSize]="true" [showFirstLastButtons]="true">
                    </mat-paginator>
            </div>

        </div>
    </div>